"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieChart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var pie_1 = require("@nivo/pie");
var getPieMargin = function (margin) {
    var defaultMargin = { top: 0, right: 0, bottom: 0, left: 0 };
    if (!!margin)
        return margin;
    return defaultMargin;
};
var getTranslateX = function (translateX) {
    var defaultTranslateX = 0;
    if (translateX)
        return translateX;
    return defaultTranslateX;
};
var getTranslateY = function (translateY) {
    var defaultTranslateY = 0;
    if (translateY)
        return translateY;
    return defaultTranslateY;
};
var getLegend = function (hasLegend, translateLegendX, translateLegendY) {
    if (!hasLegend)
        return [];
    var legend = {};
    legend.anchor = "center";
    legend.direction = "column";
    legend.justify = false;
    legend.translateX = getTranslateX(translateLegendX);
    legend.translateY = getTranslateY(translateLegendY);
    legend.itemsSpacing = 0;
    legend.itemWidth = 100;
    legend.itemHeight = 18;
    legend.itemTextColor = "#0c0c0c";
    legend.itemDirection = "left-to-right";
    legend.itemOpacity = 1;
    legend.symbolSize = 10;
    legend.symbolShape = "circle";
    return [legend];
};
var defaultColors = ["#f7820d", "#f9ab1e", "#1ac541", "#5df4ee", "#17a2b8"];
var getColors = function (colors) {
    if (colors)
        return colors;
    return defaultColors;
};
var animatedPie = function (isAnimatedProp) {
    var result = 4;
    if (isAnimatedProp !== undefined && !isAnimatedProp)
        result = 0;
    return result;
};
var PieChart = function (_a) {
    var data = _a.data, margin = _a.margin, hasLegend = _a.hasLegend, translateLegendY = _a.translateLegendY, translateLegendX = _a.translateLegendX, hasLinkLabels = _a.hasLinkLabels, colors = _a.colors, tooltipFn = _a.tooltipFn, onClickFn = _a.onClickFn, isAnimated = _a.isAnimated;
    var isInteractive = !!tooltipFn || !!onClickFn;
    var showLinkLabels = !!hasLinkLabels;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "pie-container-core" }, { children: (0, jsx_runtime_1.jsx)(pie_1.ResponsivePie, { onClick: function (node, event) {
                if (onClickFn) {
                    onClickFn(node);
                }
            }, data: data, colors: getColors(colors), margin: getPieMargin(margin), innerRadius: 0.6, enableArcLinkLabels: showLinkLabels, arcLinkLabel: "label", arcLinkLabelsDiagonalLength: 20, arcLinkLabelsStraightLength: 0, arcLinkLabelsSkipAngle: 10, arcLinkLabelsThickness: 0, enableArcLabels: false, arcLabelsSkipAngle: 10, isInteractive: isInteractive, legends: getLegend(hasLegend, translateLegendX, translateLegendY), tooltip: function (input) {
                if (tooltipFn)
                    return tooltipFn(input.datum);
                return null;
            }, animate: true, activeOuterRadiusOffset: animatedPie(isAnimated) }) })));
};
exports.PieChart = PieChart;
